import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the listing lives in en.downloads.checklists.index.tsx.
export const Route = createFileRoute("/en/downloads/checklists")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
